import React from 'react';
import { Grid } from '../../../../../CommonComponents/OPL/Grid/Grid';

export const SettingsGrid: React.FC = ({ children }) => {
  return <Grid gutter={56}>{children}</Grid>;
};
